defineDs('DanskeSpil/Framework/PlayerAccountManagement/Scripts/Components/Button', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril',
  'Shared/Framework/Mithril/Scripts/Helpers/Utils'
], function (m, Utils) {
  'use strict';

  var Button = {

    controller: function (options) {
      /**
       * The Button does the boilerplate part of loading state (Controller still handles state)
       * @param eventId {String}
       * @param classes {Object} (default, disabled, loading)
       * @param text {Object} (default, disabled, loading)
       * @param type {String} (button, submit)
       * @param disabled {Boolean}
       * @param loading {Boolean}
       * @param onclick {Function} (Callback to Controller function)
       * @example Button({
          text: { default: controller.d('CreateSubscription/SelectPayment/Button') },
          classes: { default: 'button-full-width', disabled: 'button-full-width--disabled', loading: 'button-full-width--processing' },
          loading: controller.buttonLoading,
          disabled: controller.model().fields.boolean,
          onclick: function() { controller.nextStep(); }
        })
      */
      this.options = Utils.extend(true, {
        id: null,
        eventId: null,
        uiTestId: null,
        classes: {
          default: 'pam__button',
          disabled: 'pam__button--disabled',
          loading: 'pam__button--loading'
        },
        text: {
          default: ''
        },
        href: '#',
        disabled: false,
        loading: false,
        onclick: null,
        onkeydown: null,
      }, options);

    },

    view: function (controller, args) {

      var options = controller.options;

      options.disabled = args.disabled != null ? args.disabled : options.disabled;
      options.loading = args.loading != null ? args.loading : options.loading;

      var setClasses = function () {
        var classList = options.classes.default;
        classList += options.eventId ? ' pam__button--' + options.eventId : '';
        classList += options.disabled && !options.loading ? ' ' + options.classes.disabled : '';
        classList += options.loading ? ' ' + options.classes.loading : '';
        classList += options.size ? ' pam__button--' + options.size : '';
        classList += options.color ? ' pam__button--' + options.color : '';
        classList += options.class ? ' ' + options.class : '';

        return classList;
      };

      return m('a', {
        config: function (elem) {
          if (options.id) {
            elem.setAttribute('id', options.id);
          }

          if (options.uiTestId) {
            elem.setAttribute('data-uitest-id', options.uiTestId);
          }
        },
        href: options.href,
        class: setClasses(),
        disabled: options.disabled || options.loading,
        onclick: function (e) {
          if (options.disabled || options.loading) {
            e.preventDefault();
            return;
          }
          if (!options.loading && options.onclick) {
            e.preventDefault();
            options.onclick(e);
          }
        },
        onkeydown: options.onkeydown
      }, [
        options.loading ?
          m('span', { class: 'pam__button__loader button__text' }, [
            m('span.pam__button__loader-text', options.text.loading ? options.text.loading : options.text.default),
            m('span.pam__button__loader-animation', [
              m('span', { class: 'pam__button__loader-dot' }),
              m('span', { class: 'pam__button__loader-dot' }),
              m('span', { class: 'pam__button__loader-dot' })
            ]),
          ])
          : m('span.pam__button__text', options.disabled && options.text.disabled ? options.text.disabled : options.text.default)
      ]);
    }
  };

  return Button;
});
